// extracted by mini-css-extract-plugin
export default {"content":"Page_content__Oa+oD","navBar":"Page_navBar__M26dT","navButton":"Page_navButton__nf8+6","main":"Page_main__jBW6i"};